import { Menu } from 'antd';

export default Menu;


// WEBPACK FOOTER //
// ./src/components/uielements/menu.js